import { render, staticRenderFns } from "./input-border-radius.vue?vue&type=template&id=bf7ed14c&scoped=true"
import script from "./input-border-radius.vue?vue&type=script&lang=js"
export * from "./input-border-radius.vue?vue&type=script&lang=js"
import style0 from "./input-border-radius.vue?vue&type=style&index=0&id=bf7ed14c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7ed14c",
  null
  
)

export default component.exports